import { pageLoaded } from "venuescanner-js/tools/elemental";

export default pageLoaded(() => {
  setTimeout(function () {
    const blockTabEntries = document.querySelectorAll(".block-tab");

    Array.from(blockTabEntries).forEach((element) => {
      element.addEventListener("keydown", function (e) {
        if (e.keyCode == 9) e.preventDefault();
      });
    });
  }, 1000);
});
